<template>
  <div style="background-color:black; height:100vh;">
    <v-container fluid>
      <!-- Page Header with Back Button -->
      <v-row class="pa-7" align="center" justify="space-between">
        <v-col cols="auto">
          <v-btn icon class="montserrat-button" @click="$router.go(-1)">
            <v-icon left color="white">mdi-arrow-left</v-icon>
            <span class="white--text font-weight-bold">Back</span>
          </v-btn>
        </v-col>
        <v-col cols="auto">
          <h2 class="red--text">ALL SERIAL NUMBERS</h2>
        </v-col>
        <v-col cols="auto">
          <!-- empty to balance space-between -->
        </v-col>
      </v-row>

      <!-- Search and Add Button -->
      <v-row justify="space-between" align="center" class="px-4 mb-4">
  <v-col cols="12" md="4">
    <v-text-field
      v-model="search"
      label="Search Serial Numbers"
      dense
      outlined
      prepend-inner-icon="mdi-magnify"
      class="montserrat-input"
      clearable
      dark
      background-color="rgba(255,255,255,0.1)"
      color="white"
    />
  </v-col>
  <v-col cols="12" md="3" class="text-right">
    <v-btn
      v-if="serialPermissions.Add_Button"
      color="primary"
      @click="goToAddSerial"
      class="montserrat-button"
    >
      <v-icon left>mdi-plus</v-icon>Add Serial
    </v-btn>
  </v-col>
</v-row>

      <!-- Table Card -->
      <v-row justify="center">
        <v-col cols="12" md="12">
          <v-card elevation="0" class="serial-table-card">
            <v-card-text>
              <v-overlay :value="loading">
                <v-progress-circular indeterminate size="64" />
              </v-overlay>

              <!-- Serial Numbers Table -->
              <v-data-table
                :headers="headers"
                :items="filteredSerialNumbers"
                :items-per-page="15"
                :footer-props="{
                   itemsPerPageOptions: [15, -1],
                   itemsPerPageText: 'Rows per page:'
                }"
                class="elevation-0"
                :sort-by="['primaryKey']"
                :sort-desc="[true]"
              >
                <template v-slot:item.actions="{ item }">
                  <div class="d-flex">
                    <!-- View always -->
                    <v-btn icon small @click="openViewDialog(item)">
                      <v-icon color="blue" size="20">mdi-eye</v-icon>
                    </v-btn>
                    <!-- Edit if allowed -->
                    <v-btn
                      v-if="serialPermissions.Edit_Details"
                      icon
                      small
                      @click="editSerial(item)"
                    >
                      <v-icon color="green" size="20">mdi-pencil</v-icon>
                    </v-btn>
                    <!-- Delete if admin -->
                    <v-btn
                      v-if="isAdmin"
                      icon
                      small
                      @click="confirmDeleteSerial(item)"
                    >
                      <v-icon color="red" size="20">mdi-delete</v-icon>
                    </v-btn>
                  </div>
                </template>
              </v-data-table>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>

      <!-- View Serial Dialog -->
      <v-dialog v-model="viewDialog.visible" max-width="600" class="view-dialog">
        <v-card class="view-dialog-card">
          <v-card-title class="headline pa-4">
            Serial Number Details
            <v-spacer />
            <!-- Copy -->
            <v-btn icon @click="copySerialDetails">
              <v-icon color="red">mdi-content-copy</v-icon>
            </v-btn>
            <!-- Close -->
            <v-btn icon @click="viewDialog.visible = false">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-card-title>
          <v-card-text class="pa-4">
            <v-list v-if="viewDialog.serial" dense>
              <v-list-item>
                <v-list-item-icon><v-icon color="red">mdi-key</v-icon></v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title>Certificate Number</v-list-item-title>
                  <v-list-item-subtitle>{{ viewDialog.serial.primaryKey }}</v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
              <v-list-item>
                <v-list-item-icon><v-icon color="red">mdi-link</v-icon></v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title>Serial Number</v-list-item-title>
                  <v-list-item-subtitle>{{ viewDialog.serial.linkKey }}</v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
              <v-list-item>
                <v-list-item-icon><v-icon color="red">mdi-calendar</v-icon></v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title>Date</v-list-item-title>
                  <v-list-item-subtitle>{{ viewDialog.serial.date }}</v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
              <v-list-item>
                <v-list-item-icon><v-icon color="red">mdi-account-group</v-icon></v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title>Customer</v-list-item-title>
                  <v-list-item-subtitle>{{ viewDialog.serial.customer }}</v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
              <v-list-item>
                <v-list-item-icon><v-icon color="red">mdi-file-document</v-icon></v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title>Doc Number</v-list-item-title>
                  <v-list-item-subtitle>{{ viewDialog.serial.docNumber }}</v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
              <v-list-item>
                <v-list-item-icon><v-icon color="red">mdi-cog</v-icon></v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title>Type/Code</v-list-item-title>
                  <v-list-item-subtitle>{{ viewDialog.serial.code }}</v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
              <v-list-item>
                <v-list-item-icon><v-icon color="red">mdi-cog</v-icon></v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title>Elastomers</v-list-item-title>
                  <v-list-item-subtitle>{{ viewDialog.serial.elastomers }}</v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
              <v-list-item>
                <v-list-item-icon><v-icon color="red">mdi-cog-outline</v-icon></v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title>IBS Face Material</v-list-item-title>
                  <v-list-item-subtitle>{{ viewDialog.serial.ibs }}</v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
              <v-list-item>
                <v-list-item-icon><v-icon color="red">mdi-cog-outline</v-icon></v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title>IBR Face Material</v-list-item-title>
                  <v-list-item-subtitle>{{ viewDialog.serial.ibr }}</v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
              <v-list-item>
                <v-list-item-icon><v-icon color="red">mdi-cog-outline</v-icon></v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title>OBS Face Material</v-list-item-title>
                  <v-list-item-subtitle>{{ viewDialog.serial.obs }}</v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
              <v-list-item>
                <v-list-item-icon><v-icon color="red">mdi-cog-outline</v-icon></v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title>OBR Face Material</v-list-item-title>
                  <v-list-item-subtitle>{{ viewDialog.serial.obr }}</v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
              <v-list-item>
                <v-list-item-icon><v-icon color="red">mdi-ruler</v-icon></v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title>Shaft Size</v-list-item-title>
                  <v-list-item-subtitle>{{ viewDialog.serial.shaftSize }}</v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
              <v-list-item>
                <v-list-item-icon><v-icon color="red">mdi-note</v-icon></v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title>Notes</v-list-item-title>
                  <v-list-item-subtitle>{{ viewDialog.serial.notes || 'None' }}</v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
            </v-list>
          </v-card-text>
        </v-card>
      </v-dialog>

      <!-- Unallowed Dialog -->
      <v-dialog v-model="unallowedDialog.visible" max-width="400">
        <v-card class="unallowed-dialog-card">
          <v-card-title class="headline pa-4">Permission Denied</v-card-title>
          <v-card-text>
            You do not have permission to perform this action. Please contact an administrator.
          </v-card-text>
          <v-card-actions>
            <v-spacer />
            <v-btn color="primary" text @click="unallowedDialog.visible = false">
              <v-icon left>mdi-close</v-icon>Close
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <!-- Delete Confirmation Dialog -->
      <v-dialog v-model="confirmationDialog.visible" max-width="400">
        <v-card class="confirmation-dialog-card">
          <v-card-title class="headline pa-4">{{ confirmationDialog.title }}</v-card-title>
          <v-card-text>{{ confirmationDialog.message }}</v-card-text>
          <v-card-actions>
            <v-spacer />
            <v-btn color="primary" text @click="confirmationDialog.confirm">
              <v-icon left>mdi-check</v-icon>Yes
            </v-btn>
            <v-btn color="grey" text @click="confirmationDialog.visible = false">
              <v-icon left>mdi-close</v-icon>No
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <!-- Snackbars -->
      <v-snackbar v-model="successSnackbar" color="success" timeout="3000">
        {{ successMessage }}
        <v-btn color="white" text @click="successSnackbar = false">Close</v-btn>
      </v-snackbar>
      <v-snackbar v-model="errorSnackbar" color="error" timeout="3000">
        {{ errorMessage }}
        <v-btn color="white" text @click="errorSnackbar = false">Close</v-btn>
      </v-snackbar>
      <v-snackbar v-model="copySnackbar" color="info" timeout="3000" top>
        {{ copySuccessMessage }}
        <v-btn color="white" text @click="copySnackbar = false">Close</v-btn>
      </v-snackbar>
    </v-container>
  </div>
</template>

<script>
import {
  getFirestore,
  collection,
  getDocs,
  doc,
  deleteDoc,
  getDoc
} from "firebase/firestore";
import { firebaseApp, auth } from "@/firebaseConfig";

const db = getFirestore(firebaseApp);

export default {
  name: "AllSerialNumber",
  data() {
    return {
      loading: false,
      search: "",
      serialNumbers: [],
      serialPermissions: {
        Add_Button: false,
        Edit_Details: false,
        View_in_Functions: false,
        View_in_Activities: false,
        Override_All: false
      },
      isAdmin: false,
      headers: [
        { text: "Certificate Number", value: "primaryKey", sortable: true },
        { text: "Serial Number", value: "linkKey", sortable: true },
        { text: "Date", value: "date", sortable: true },
        { text: "Customer", value: "customer", sortable: true },
        { text: "Doc Number", value: "docNumber", sortable: true },
        { text: "Type/Code", value: "code", sortable: true },
        { text: "Elastomers", value: "elastomers", sortable: true },
        { text: "IBS", value: "ibs", sortable: true },
        { text: "IBR", value: "ibr", sortable: true },
        { text: "OBS", value: "obs", sortable: true },
        { text: "OBR", value: "obr", sortable: true },
        { text: "Shaft Size", value: "shaftSize", sortable: true },
        { text: "Notes", value: "notes", sortable: false },
        { text: "Actions", value: "actions", sortable: false }
      ],
      viewDialog: {
        visible: false,
        serial: null
      },
      unallowedDialog: {
        visible: false
      },
      confirmationDialog: {
        visible: false,
        title: "",
        message: "",
        confirm: () => {}
      },
      successSnackbar: false,
      successMessage: "",
      errorSnackbar: false,
      errorMessage: "",
      copySnackbar: false,
      copySuccessMessage: ""
    };
  },
  computed: {
    filteredSerialNumbers() {
      if (!this.search.trim()) return this.serialNumbers;
      const s = this.search.trim().toLowerCase();
      return this.serialNumbers.filter(item =>
        [
          item.primaryKey,
          item.linkKey,
          item.date,
          item.customer,
          item.docNumber,
          item.code,
          item.elastomers,
          item.ibs,
          item.ibr,
          item.obs,
          item.obr,
          item.shaftSize,
          item.notes
        ].some(v => v && v.toString().toLowerCase().includes(s))
      );
    }
  },
  async created() {
    this.loading = true;
    try {
      const user = auth.currentUser;
      if (!user) throw new Error("No user is logged in");

      // load permissions
      const userRef = doc(db, "users", user.uid);
      const userSnap = await getDoc(userRef);
      if (userSnap.exists()) {
        const data = userSnap.data();
        this.isAdmin = data.role === "Admin";
        if (data.serial) {
          this.serialPermissions = {
            Add_Button: data.serial.Add_Button || false,
            Edit_Details: data.serial.Edit_Details || false,
            View_in_Functions: data.serial.View_in_Functions || false,
            View_in_Activities: data.serial.View_in_Activities || false,
            Override_All: data.serial.Override_All || false
          };
        }
      }

      // load serial numbers
      const col = collection(db, "SerialNumber");
      const snap = await getDocs(col);
      this.serialNumbers = snap.docs.map(d => ({
        id: d.id,
        ...d.data()
      }));
    } catch (e) {
      console.error("Error loading serial numbers:", e);
      this.errorMessage = "Failed to load serial numbers.";
      this.errorSnackbar = true;
    } finally {
      this.loading = false;
    }
  },
  methods: {
    openViewDialog(item) {
      this.viewDialog.serial = item;
      this.viewDialog.visible = true;
    },
    editSerial(item) {
      if (!this.serialPermissions.Edit_Details) {
        this.unallowedDialog.visible = true;
        return;
      }
      localStorage.setItem("selectedSerialId", item.id);
      this.$router.push({ name: "EditSerialNumber" });
    },
    confirmDeleteSerial(item) {
      this.confirmationDialog = {
        visible: true,
        title: "Confirm Delete",
        message: `Are you sure you want to delete Serial #${item.primaryKey}?`,
        confirm: () => this.deleteSerial(item)
      };
    },
    async deleteSerial(item) {
      this.loading = true;
      try {
        await deleteDoc(doc(db, "SerialNumber", item.id));
        this.successMessage = `Serial #${item.primaryKey} deleted successfully!`;
        this.successSnackbar = true;
        // refresh list
        const col = collection(db, "SerialNumber");
        const snap = await getDocs(col);
        this.serialNumbers = snap.docs.map(d => ({ id: d.id, ...d.data() }));
      } catch (e) {
        console.error("Error deleting serial:", e);
        this.errorMessage = "Failed to delete serial number.";
        this.errorSnackbar = true;
      } finally {
        this.loading = false;
        this.confirmationDialog.visible = false;
      }
    },
    goToAddSerial() {
      if (!this.serialPermissions.Add_Button) {
        this.unallowedDialog.visible = true;
        return;
      }
      this.$router.push({ name: "AddSerialNumber" });
    },
    async copySerialDetails() {
      const s = this.viewDialog.serial;
      if (!s) return;
      const text = `
Certificate Number: ${s.primaryKey}
Serial Number:      ${s.linkKey}
Date:               ${s.date}
Customer:           ${s.customer}
Doc Number:         ${s.docNumber}
Type/Code:          ${s.code}
Elastomers:         ${s.elastomers}
IBS Face Material:  ${s.ibs}
IBR Face Material:  ${s.ibr}
OBS Face Material:  ${s.obs}
OBR Face Material:  ${s.obr}
Shaft Size:         ${s.shaftSize}
Notes:              ${s.notes || "None"}
      `.trim();
      try {
        await navigator.clipboard.writeText(text);
        this.copySuccessMessage = "All fields copied to clipboard!";
      } catch {
        this.copySuccessMessage = "Copy failed. Please try again.";
      } finally {
        this.copySnackbar = true;
      }
    }
  }
};
</script>

<style scoped>
@import url("https://fonts.googleapis.com/css2?family=Montserrat:wght@400;700&display=swap");

.serial-table-card {
  box-shadow: 10px 10px 20px #1b1c1e, -10px -10px 20px #c4242b;
  border-radius: 20px;
  margin-top: 20px;
  padding: 20px;
  background-color: #ffffff;
  transition: all 0.3s ease-in-out;
}

.montserrat-input,
.montserrat-button {
  font-family: "Montserrat", sans-serif;
}

/* Table header styling */
.v-data-table-header {
  background-color: #c4242b !important;
}
.v-data-table-header th {
  color: white !important;
  font-weight: 700;
}

/* Row hover effect */
.v-data-table tbody tr:hover {
  background-color: rgba(196, 36, 43, 0.1) !important;
}

/* Dialog cards */
.confirmation-dialog-card,
.unallowed-dialog-card,
.view-dialog-card {
  border-radius: 8px;
}
.view-dialog-card .headline {
  background-color: #c4242b;
  color: white;
}

/* Button */
.v-btn.primary {
  background-color: #c4242b !important;
  color: white !important;
  border-radius: 8px;
  transition: all 0.2s ease-in-out;
}
.v-btn.primary:hover {
  background-color: #a31f24 !important;
  transform: translateY(-1px);
}

.montserrat-button {
  font-weight: 700;
  letter-spacing: 1px;
}
</style>
